import now from 'lodash/now';

import * as Types from 'types';

export const getFirstNewEdition = (editions: Types.Edition[]) =>
  editions.find((edition) => editionIsNew(edition));

const dayAgo = () => now() - 86400000;

export const editionIsNew = (edition: Types.Edition) => {
  return edition.certificate.updatedAt >= dayAgo();
};
